import { render } from "./ScrollPage.vue?vue&type=template&id=86acc2ec"
import script from "./ScrollPage.vue?vue&type=script&lang=js"
export * from "./ScrollPage.vue?vue&type=script&lang=js"

import "./ScrollPage.vue?vue&type=style&index=0&id=86acc2ec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__